<template>
  <div>
    <services-manager></services-manager>
    <status-page></status-page>
  </div>
</template>

<script>
import ServicesManager from './ServicesManager'
import StatusPage from './StatusPage'

export default {
  components: {
    ServicesManager,
    StatusPage
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dashboard/Dashboard.vue